var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReburgerMarkLogo = function SvgReburgerMarkLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ReburgerMarkLogo_svg__Layer_1",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ReburgerMarkLogo_svg__cls-2{stroke-width:0;fill:#eaa300}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v14.34H0zM0 45.66h60V60H0z",
    className: "ReburgerMarkLogo_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.13 23.9c8.6-3.69 18.93-8.11 32.87-1.92v14.24c-11.65-6.57-18.21-3.99-27.21-.13-5.48 2.35-11.67 5.01-19.05 5.01-4.17 0-8.72-.85-13.73-3.08V23.75c11.59 6.57 18.15 4 27.13.15Z",
    style: {
      fill: "#bf000a",
      strokeWidth: 0
    }
  }));
};
export default SvgReburgerMarkLogo;